// Shared lookup for the display-only `custom.special_price_ui` metafield (integer cents; 0 = none).
//
// Rebuy's product feed omits this metafield, so anywhere Rebuy renders a card — the Smart Cart
// "Customers also added" cross-sell (rebuy-ui-discount.js) and the Frequently-Bought add-on cards
// (react/frequently-bought.js) — reads it from the theme's own JSON endpoint:
// templates/product.discount.liquid, fetched at /products/{handle}?view=discount.
//
// REQUIRES templates/product.discount.liquid on the theme. NOTE: do NOT send `Accept: text/plain`
// — the `shopify theme dev` proxy 404s `?view=` requests carrying that header. The `{% layout none %}`
// template returns bare JSON as text/html; we JSON.parse it regardless, so no Accept header is needed.

// Per-handle promise cache so N cards for the same product hit the endpoint once.
// ponytail: cache lives for the page load only — a merchant editing special_price_ui mid-session
// won't show until reload. Add a TTL only if that becomes a real workflow.
const cache = new Map();

export const fetchVariantSpecials = (handle) => {
    if (!cache.has(handle)) {
        cache.set(
            handle,
            fetch(`/products/${handle}?view=discount`)
                .then((response) => {
                    if (!response.ok) throw new Error(`discount view ${response.status}`);
                    return response.json();
                })
                .then((data) => data.variants || {})
                .catch((error) => {
                    // Never break a card on a failed lookup — degrade to "no special".
                    console.error(`special-price-lookup: failed for ${handle}:`, error);
                    return {};
                })
        );
    }
    return cache.get(handle);
};

export default fetchVariantSpecials;
